import { render, staticRenderFns } from "./FoodSafetySummary.vue?vue&type=template&id=1645c57e"
import script from "./FoodSafetySummary.vue?vue&type=script&lang=js"
export * from "./FoodSafetySummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports